import * as React from 'react'
import { Row, Col, Form, FormGroup, FormControl, ControlLabel, Alert } from 'react-bootstrap'
import StaticModal from './StaticModal'
import LoadIndicator from './LoadIndicator'

interface LoginModalProps {
	respondToLogin: () => void
}

const LoginModal: React.FunctionComponent<LoginModalProps> = (props) => {
	const [username, setUsername] = React.useState('')
	const [password, setPassword] = React.useState('')
	const [errorMsg, setErrorMsg] = React.useState('')
	const [loading, setLoading] = React.useState(false)

	const handleLogin = async () => {
		setErrorMsg('')
		setLoading(true)
		const resp = await fetch('/api/users/login', {
			credentials: 'same-origin',
			method: 'POST',
			body: JSON.stringify({ username, password }),
		})
		if (resp.ok) {
			const status = await resp.json()
			if (status === 'OK') {
				await props.respondToLogin()
			} else {
				const msg = 'Login failed. Please check username and password and try again.'
				setErrorMsg(msg)
			}
		}
		setLoading(false)
	}

	const title = 'Your session has expired. Please log in to continue.'

	const renderErrors = () => {
		return (
			<Row>
				<Col mdOffset={1} md={10} smOffset={1} sm={10}>
					<Alert bsStyle={'danger'}>
						<h5>{errorMsg}</h5>
					</Alert>
				</Col>
			</Row>
		)
	}

	const loadIndicator = () => {
		if (loading) {
			return <LoadIndicator />
		}
	}

	const linkStyle = {
		marginBottom: '10px',
		font: 'icon',
	}

	return (
		<StaticModal modalName="log_in" title={title} footer={true} handleButton={handleLogin} closeButtonText="Login">
			{loading ? (
				loadIndicator()
			) : (
				<>
					{errorMsg && renderErrors()}
					<Row>
						<Col mdOffset={1} md={10} smOffset={1} sm={10} style={linkStyle}>
							<a href="/login">Click here to login with Google or Microsoft</a>
						</Col>
						<Col mdOffset={1} md={10} smOffset={1} sm={10}>
							<Form>
								<FormGroup controlId="signupEmail">
									<ControlLabel>Email</ControlLabel>
									<FormControl
										type="email"
										value={username}
										onChange={(e: any) => setUsername(e.target.value)}
									/>
								</FormGroup>

								<FormGroup controlId="password">
									<ControlLabel>Password</ControlLabel>
									<FormControl
										type="password"
										value={password}
										onChange={(e: any) => setPassword(e.target.value)}
									/>
								</FormGroup>
							</Form>
						</Col>
					</Row>
				</>
			)}
		</StaticModal>
	)
}

export default LoginModal
